import React from 'react';
import { Notification } from '@deal/components';
import LoginLinkHandler from '../LoginLinkHandler/index.js';

var CreaetAccountViewModel = function CreaetAccountViewModel(_ref) {
  var createAccountViewModel = _ref.createAccountViewModel;

  /**
   * If there as an error creating the account as a standalone action then show this notification.
   */
  if (createAccountViewModel.createAccountError) {
    return React.createElement(Notification, {
      type: "error"
    }, createAccountViewModel.createAccountError.errorMessage, " ", React.createElement(LoginLinkHandler, null));
  }

  return null;
};

export default CreaetAccountViewModel;
//# sourceMappingURL=index.js.map
